import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { ProjectDetailPage } from '@/pages/projects/ui/ProjectDetailPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';
import { projectDetailTabSchema } from '@/widgets/right-side-menu/ui/ai-chat/project-detail/projectDetailTab';

const querySchema = z.object({
  /** AIチャットのスレッドID */
  threadId: z.string().optional(),
  /** AIサイドパネルの選択タブ（matching / chat）。未指定時は chat 相当 */
  tab: projectDetailTabSchema.optional(),
});

export const Route = createFileRoute('/_protected/projects/$projectId/')({
  component: ProjectDetailPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: querySchema,
      defaultValues: {},
    }),
});
